import * as types from "../mutation-types";
import appConfig from "../../appconfig";
import {mapFeatureToggles} from "../../libraries/utils";
import engineFactory from "json-rules-engine";
import jwt_decode from "jwt-decode";

const rulesEngine = engineFactory([], { allowUndefinedFacts: true });

const randomAssignment = () => {
	// legacy session refers to jwt session token that were previously generated on server side for ab testing.
	// the token was valid for 1 month, it should be safe to remove this legacy handler after 2 month of this commit.
	const abTestingSession = localStorage.getItem("abTestingSession");
	const legacySession = abTestingSession && jwt_decode(abTestingSession);
	if (legacySession && legacySession.pct) {
		localStorage.removeItem("abTestingSession");
		return legacySession.pct;
	}

	return Math.random() * 100;
};

const getVariants = () => new Set((localStorage.getItem("abTesting") || "").split(",").filter(Boolean));

const updateVariants = (variants = []) => {
	const variantsArr = [...variants].join(",");
	if (!variantsArr || !variantsArr.length) { localStorage.removeItem("abTesting"); }
	else { localStorage.setItem("abTesting", variantsArr); }
};

// initial state
const state = {
	persistedData: {
		userPct: randomAssignment()
	}
};

// getters
const getters = {
	userPct: state => state.persistedData.userPct
};

// actions
const actions = {
	startABTesting({ getters, rootGetters, commit, dispatch }, { tests, preview = false }) {
		updateVariants();

		if (!tests || !tests.length || !Array.isArray(tests)) {
			return;
		}

		tests.map(test => test.variants).flat().forEach(variant => rulesEngine.addRule(variant.rule));

		const addFacts = (fact) => dispatch("addABFacts", fact);
		addFacts({ preview, percentage: getters.userPct, channel: appConfig.channelAlias() });

		rulesEngine.on("success", (event, _almanac, ruleResult) => {
			const { featureToggles } = event.params;
			const mappedFeatureToggles = mapFeatureToggles(featureToggles);
			const updatedFeatureToggles = { ...getters.featureToggles, ...mappedFeatureToggles };
			commit(types.SET_FEATURE_TOGGLES, updatedFeatureToggles);

			const variants = getVariants();
			variants.delete(`${ruleResult.name}_control`);
			variants.add(ruleResult.name);
			updateVariants(variants);
		});

		rulesEngine.on("failure", (_event, _almanac, ruleResult) => { 
			const variants = getVariants();
			variants.delete(ruleResult.name);
			variants.add(`${ruleResult.name}_control`);
			updateVariants(variants);
		});

		this.watch(() => rootGetters.globalSelectedShop, (value) => addFacts({ shopId: (value || {}).id }));
		this.watch(() => rootGetters.customerEvaluationData, (value) => addFacts({ customerType: (value || {}).customerType }));
	},

	addABFacts(_, facts) {
		Object.entries(facts).forEach(([key, value]) => rulesEngine.addFact(key, value));
		rulesEngine.run().catch(error => console.warn("AB testing runner encountered an error", error)); // eslint-disable-line no-console
	}
};

// mutations
const mutations = {};

export default {
	state,
	getters,
	actions,
	mutations
};
